import { render } from "./SubAccountCardEmpty.vue?vue&type=template&id=3c8062a4&scoped=true"
const script = {}

import "./SubAccountCardEmpty.vue?vue&type=style&index=0&id=3c8062a4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3c8062a4"

export default script